import { BoxStyleProps } from "@twilio-paste/core/box";

export const outerContainerStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
};

export const innerContainerStyles: BoxStyleProps = {
    boxShadow: "shadow",
    display: "flex",
    flexDirection: "column",
    marginBottom: "space50",
    borderRadius: "borderRadius30",
    backgroundColor: "colorBackgroundBody",
    height: "520px",
    width: "320px"
};

export const entryPointStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "row-reverse"
}
